<div>
    <app-software-registration-form></app-software-registration-form>
</div>

<div>
    <app-software-registration-list></app-software-registration-list>
</div>